/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import entityTableTemplate from '../table/entity-table.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function GatewayGroupRoutes($stateProvider, $injector) {

    var types = $injector.get('types');

    $stateProvider
        .state('home.gatewayGroups', {
            url: '/gatewayGroups',
            module: 'private',
            auth: [types.authority.PROVIDER_ADMIN.value, types.authority.PROVIDER_USER.value,
                   types.authority.CUSTOMER_ADMIN.value, types.authority.CUSTOMER_USER.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'gateway-group.gateway-groups'
            },
            ncyBreadcrumb: {
                label: '{"icon": "router", "label": "gateway-group.gateway-groups"}'
            },
            params: {
                entityId: null,
            },
            resolve: {
                entityTableConfiguration:
                /*@ngInject*/
                    function($stateParams, gatewayGroupTableConfig) {
                        return gatewayGroupTableConfig.getConfig($stateParams);
                    }
            }
        })
        .state('home.customers.gatewayGroups', {
            url: '/:customerId/gatewayGroups',
            module: 'private',
            auth: [types.authority.PROVIDER_ADMIN.value, types.authority.PROVIDER_USER.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'gateway-group.gateway-groups'
            },
            ncyBreadcrumb: {
                label: '{"icon": "router", "label": "gateway-group.gateway-groups"}'
            },
            resolve: {
                entityTableConfiguration:
                /*@ngInject*/
                    function($stateParams, gatewayGroupTableConfig) {
                        return gatewayGroupTableConfig.getConfig($stateParams);
                    }
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/gateway-group/gateway-group.routes.js